var map = {
	"./gadgets_data_normal@3x.png": "97b8",
	"./gadgets_data_pressed@3x.png": "28ea",
	"./gadgets_settings_normal@3x.png": "d772",
	"./gadgets_settings_pressed@3x.png": "261e",
	"./ipt_minus_no.png": "e279",
	"./ipt_minus_yes.png": "9ccf",
	"./ipt_plus_no.png": "8f0f",
	"./ipt_plus_yes.png": "c509",
	"./random_icon@3x.png": "6cc7",
	"./terminal_icon@3x.png": "c54f",
	"./timer_icon@3x.png": "cd3c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fc57";